<template>
    <v-card>
        <v-card-title>
            {{ title }}
        </v-card-title>
        <v-card-subtitle>
            {{ subtitle }}
        </v-card-subtitle>
        <v-card-text>
            <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formattedDate"
                        label="Choose date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    />
                </template>
                <v-date-picker
                    v-model="date"
                    scrollable
                >
                    <v-spacer />
                    <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(date)"
                    >
                        OK
                    </v-btn>
                </v-date-picker>
            </v-dialog>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-dialog
                v-model="confirmationDialog"
                width="500"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="date === ''"
                    >
                        Delete
                    </v-btn>
                </template>

                <v-card>
                    <v-card-title>
                        Are you sure?
                    </v-card-title>

                    <v-card-text>
                        <p>
                            This will dismiss all submissions with submission date on or before <strong>{{ formattedDate }}</strong>.
                        </p>
                        <p>
                            This cannot be undone!
                        </p>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            color="primary"
                            text
                            @click="confirmationDialog = false"
                            :disabled="loading"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="submit"
                            :disabled="loading"
                        >
                            Delete
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from 'moment';

export default {
    name: "MassDismissCard",

    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        route: {
            type: String,
            required: true,
        }
    },
    
    data: () => ({
        date: '',
        modal: false,
        confirmationDialog: false,
        loading: false,
    }),

    computed: {
        formattedDate() {
            return this.date ? moment(this.date).format('Do MMMM YYYY') : ''
        },
    },

    methods: {
        submit() {
            this.loading = true;
            axios
                .post(this.route, {
                    date: this.date
                })
                .catch(console.log)
                .finally(response => {
                    this.confirmationDialog = false;
                    this.loading = false;
                });
        }
    }
}
</script>